import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-6">Ultimo aggiornamento: 17 Gennaio 2026</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Titolare del Trattamento</h2>
              <p className="text-gray-700 mb-2">
                <strong>SERVICE 360 TOTAL SOLUTIONS LTD</strong><br />
                VAT: BG205967958<br />
                Indirizzo: Str. Dr Anastasiya Zhelezkova 35, 9000 Varna, Bulgaria<br />
                Rappresentante Legale: Ugo Filosa<br />
                Email: info@offroaditalia.com<br />
                WhatsApp: +39 379 379 3030
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Tipologie di Dati Raccolti</h2>
              <p className="text-gray-700 mb-4">Raccogliamo e trattiamo i seguenti dati personali:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Dati identificativi:</strong> Nome, cognome, data e luogo di nascita</li>
                <li><strong>Dati di contatto:</strong> Email, numero di telefono, WhatsApp</li>
                <li><strong>Dati del documento:</strong> Numero di passaporto (per eventi internazionali)</li>
                <li><strong>Dati di preferenza:</strong> Scelta moto, tipo camera, intolleranze alimentari, taglia abbigliamento</li>
                <li><strong>Dati di navigazione:</strong> Cookie tecnici e analytics</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Finalità del Trattamento</h2>
              <p className="text-gray-700 mb-4">I dati personali sono trattati per le seguenti finalità:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Gestione delle iscrizioni agli eventi</li>
                <li>Organizzazione logistica (hotel, pasti, noleggio moto)</li>
                <li>Comunicazioni relative agli eventi</li>
                <li>Adempimenti contabili e fiscali</li>
                <li>Risposta a richieste di informazioni</li>
                <li>Miglioramento dei servizi offerti (con consenso per analytics)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Base Giuridica</h2>
              <p className="text-gray-700 mb-4">Il trattamento dei dati si basa su:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Esecuzione del contratto:</strong> Per gestire la tua iscrizione agli eventi</li>
                <li><strong>Obbligo di legge:</strong> Per adempimenti fiscali e contabili</li>
                <li><strong>Consenso:</strong> Per l'invio di comunicazioni marketing (opzionale)</li>
                <li><strong>Interesse legittimo:</strong> Per migliorare i nostri servizi</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Modalità di Trattamento</h2>
              <p className="text-gray-700 mb-4">
                I dati sono trattati con strumenti informatici e telematici, con logiche strettamente correlate alle finalità indicate. 
                Adottiamo misure di sicurezza organizzative, tecniche e fisiche adeguate per proteggere i dati da accessi non autorizzati, 
                perdita, distruzione o alterazione.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Conservazione dei Dati</h2>
              <p className="text-gray-700">
                I dati personali saranno conservati per il tempo necessario a soddisfare le finalità per cui sono stati raccolti e per 
                adempiere agli obblighi di legge (10 anni per documenti contabili e fiscali). I dati forniti per richieste di informazioni 
                saranno conservati per 2 anni.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Comunicazione e Diffusione</h2>
              <p className="text-gray-700 mb-4">I dati possono essere comunicati a:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Partner logistici (hotel, ristoranti, noleggio moto)</li>
                <li>Fornitori di servizi IT e hosting</li>
                <li>Professionisti e consulenti (commercialisti, avvocati)</li>
                <li>Autorità pubbliche per obblighi di legge</li>
              </ul>
              <p className="text-gray-700 mt-4">I dati non saranno in alcun modo diffusi.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Diritti dell'Interessato</h2>
              <p className="text-gray-700 mb-4">Ai sensi del GDPR (Regolamento UE 2016/679), hai diritto di:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Accesso:</strong> Ottenere conferma dell'esistenza dei tuoi dati e riceverne copia</li>
                <li><strong>Rettifica:</strong> Correggere dati inesatti o incompleti</li>
                <li><strong>Cancellazione:</strong> Richiedere la cancellazione dei dati ("diritto all'oblio")</li>
                <li><strong>Limitazione:</strong> Limitare il trattamento in determinate circostanze</li>
                <li><strong>Portabilità:</strong> Ricevere i dati in formato strutturato e trasmetterli ad altro titolare</li>
                <li><strong>Opposizione:</strong> Opporti al trattamento per motivi legittimi</li>
                <li><strong>Revoca del consenso:</strong> Revocare il consenso in qualsiasi momento</li>
              </ul>
              <p className="text-gray-700 mt-4">
                Per esercitare questi diritti, contattaci a: <a href="mailto:info@offroaditalia.com" className="text-blue-600 hover:text-blue-700">info@offroaditalia.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Reclamo all'Autorità di Controllo</h2>
              <p className="text-gray-700">
                Hai il diritto di proporre reclamo all'autorità di controllo competente (Garante per la Protezione dei Dati Personali - Italia, 
                o Commission for Personal Data Protection - Bulgaria) se ritieni che il trattamento violi il GDPR.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Modifiche alla Privacy Policy</h2>
              <p className="text-gray-700">
                Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina 
                con indicazione della data di ultimo aggiornamento.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Cookie</h2>
              <p className="text-gray-700">
                Per informazioni sui cookie utilizzati, consulta la nostra <Link to="/cookie-policy" className="text-blue-600 hover:text-blue-700">Cookie Policy</Link>.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-8 border-t">
            <Link to="/" className="text-blue-600 hover:text-blue-700 font-semibold">
              ← Torna alla Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;